import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap";
import '@/assets/styles/custom.scss';

Vue.config.productionTip = false

import Toast, {POSITION} from 'vue-toastification'
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
    position: POSITION.BOTTOM_RIGHT
});

import '@/plugins/fontawesome'

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

// Cloudinary
import Cloudinary from 'cloudinary-vue';

Vue.use(Cloudinary, {
    configuration: {
        cloudName: "spaboot"
    }
});

import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: 'vc',
    locale: 'de-DE',
    timezone: 'Europe/Berlin'
});


import spabootApi from './spaboot-api'

Vue.prototype.$api = spabootApi

Vue.filter('price', function (p) {
    if (!p)
        return 0.0;
    return p.toFixed(2).toLocaleString() + '€'
});

Vue.filter('num', function (p) {
    if (!p)
        return 0.0;
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits:2
    }).format(p)
});

Vue.filter('paymentState', function (p) {
    if (!p)
        return 'unbekannt'
    if (p === 'NOT_PAID')
        return 'noch nicht bezahlt'
    else
        return 'bezahlt'
});

Vue.filter('orderState', function (p) {
    if (p === 'NEW')
        return 'new'
    if (p === 'OPEN')
        return 'noch offen'
    if (p === 'FULFILLED')
        return 'abgeschlossen'
    if (p === 'CANCELED')
        return 'sorniert'
});

import {DateTime} from "luxon";

Vue.filter('dateTime', function (d) {
    if (!d)
        return '';
    let dt = DateTime.fromJSDate(new Date(d)).setLocale('de')
    return dt.weekdayShort + ', ' + dt.toFormat('dd.MM.yy HH:mm')
});

Vue.filter('shortDateTime', function (d) {
    if (!d)
        return '';
    let dt = DateTime.fromJSDate(new Date(d)).setLocale('de')
    return dt.toFormat('dd.MM.yy HH:mm')
});

Vue.filter('date', function (d) {
    if (!d)
        return '';
    let dt = DateTime.fromJSDate(new Date(d)).setLocale('de')
    return dt.weekdayShort + ', ' + dt.toFormat('dd.MM.yy')
});

Vue.filter('shortDate', function (d) {
    if (!d)
        return '';
    let dt = DateTime.fromJSDate(new Date(d)).setLocale('de')
    return dt.toFormat('dd.MM.yy')
});

Vue.prototype.$channel = process.env.VUE_APP_SPABOOT_CHANNEL

import MessagesMixin from "@/mixins/MessagesMixin";

Vue.mixin(MessagesMixin)

Vue.config.errorHandler = (err, vm, info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.

    // TODO: Perform any custom logic or log to server
    console.log('vue error handler: ' + err + ' / ' + info)
};

window.onerror = function (message, source, lineno, colno, error) {
    console.log('window.onerror: ' + message + ' / ' + source + ' / ' + lineno + ' / ' + colno + ' / ' + error)
}

import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
Vue.component('typeahead', VueTypeaheadBootstrap)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
